<script>
import Header from '@/components/Header.vue'

export default {
	name: 'IndexAuth',
	components: {
		Header,
	},
	data() {
		return {
			mobileStatus: false,
		}
	},
	methods: {
		mobileActive(status) {
			this.mobileStatus = status
		},
	},
}
</script>

<template>
	<div class="wrapper">
		<Header @mobileActive="mobileActive"></Header>

		<router-view />
	</div>
</template>
